/**
 * Fallback UI for `SsapSummaryErrorBoundary` (SSAP Final Review / comparison only). Relies on the
 * surrounding app `IntlProvider` (`FormattedMessage`). Primary action: `restoreAction` (Redux-backed
 * summary refresh), not a full page reload.
 *
 * For SSAP route fatal errors use `ApplicationErrorFallback` (`components/common/ApplicationErrorFallback.jsx`).
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@cmsgov/design-system';

import ClientErrorFallbackLayout from '../common/ClientErrorFallbackLayout';

const SsapSummaryFallback = props => {
    const { restoreAction, stateCode } = props;

    return (
        <ClientErrorFallbackLayout
            mainId="gi-ssap-summary-fallback__container"
            headerId="error-header"
            stateCode={stateCode}
        >
            <Button className="usa-button gi-button gi-button__primary" onClick={restoreAction}>
                <FormattedMessage id="button.refresh_summary" />
            </Button>
        </ClientErrorFallbackLayout>
    );
};

export default SsapSummaryFallback;
